import React, { Component, useRef } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Nav, Accordion } from "react-bootstrap";
import { handleActiveLink, handleLeft } from '../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp, userrole } from '../../GlobalModules/Login/Actions/LoginAction';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Utility from '../Utility'
import Logs from '../Logs/Components/Logs';
import ModalGlobal from '../Components/ModalGlobal';
import ErrorBoundary from '../Components/ErrorBoundary';

class Left extends Component {
	constructor(props) {
		super(props);
		this.handleBar = this.handleBar.bind(this);
		this.state = {
			toggleType: "",
			activeClass: "",
			accName: "",
			subMenuIcon: "",
			isOpen: false,
			isMobile: window.innerWidth <= 767,
			logsPopupFlag: false,
		}
		this.sidebarOutsideClickRef = React.createRef();
	}

	toggle = (params, linkType, agentModule = '') => {
		let splitUrl = this.props.history.location.pathname;
		if (params == 'revenue_module' && splitUrl.includes('/revenue-manager')) {
			window.location.reload();
			return;
		}
		if (linkType === "") {
			this.setState({
				collapsed2: true,
				accName: ""
			}, () => {
				this.props.handleActiveLink(this.state.activeClass, this.state.accName)

			});
		}
		localStorage.setItem("selectedTabName", "");
		if (this.state.isMobile) {
			const moduleFromParams = params.replace('_module', '');
			const moduleFromUrl = splitUrl.split('/')[2];
			let userType = ['agent', 'agent_staff']
			if (userType.includes(this.props.userCredentials.user_details?.user_type)) {
				if (agentModule !== moduleFromUrl) {
					this.props.handleLeft(!this.props.leftbar)
				} else {
					this.props.handleLeft(false)
				}
			} else {
				if (moduleFromParams !== moduleFromUrl) {
					this.props.handleLeft(!this.props.leftbar)
				} else {
					this.props.handleLeft(false)
				}
			}
			this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
		}
		this.setState({
			activeClass: params
		}, () => {
			this.props.handleActiveLink(this.state.activeClass, this.state.accName)
		});
	}

	handleBar = () => {
		this.props.handleLeft(!this.props.leftbar)
	}
	validationPermission = (eventKey) => {
		const { t, roleWisePermission } = this.props;
		let valid = false;
		if (roleWisePermission && roleWisePermission.hasOwnProperty(eventKey) && roleWisePermission[eventKey].read_write_permission != "") {
			valid = true;
		}
		return valid
	}

	handleClickOutsideSidebar(event) {
		if (this.sidebarOutsideClickRef.current != null) {
			if (this.sidebarOutsideClickRef && this.sidebarOutsideClickRef.current && !this.sidebarOutsideClickRef.current.contains(event.target)) {
				this.setState({
					isOpen: false
				})
				this.props.handleLeft(false)
			}
		}

	}

	leftUi = () => {
		const { t, roleWisePermission, userCredentials } = this.props;
		const { activeClass, accName } = this.props.activeLink;
		let arry = []
		// let settingsPermission = false;
		// if (Object.keys(Utility.getRoleObjectByEventKey('booking_rules')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('cancellation_rules')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('amenities')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('tax')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('role')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('room_facility')).length > 0) {
		// 	settingsPermission = true;
		// }
		// Check if user has access to any settings-related features
		const settingsModules = ['booking_rules', 'cancellation_rules', 'amenities', 'tax', 'role', 'room_facility', 'register_master_folio', 'slot_configuration', 'booking_engine_setting', 'coupon'];
		const settingsPermission = settingsModules.some(module =>
			Object.keys(Utility.getRoleObjectByEventKey(module)).length > 0
		);
		//For agent
		let settingsPermissionForAgent = false;
		if (Object.keys(Utility.getRoleObjectByEventKey('role')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('advance_percent')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('cancellation_rules')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('amenities')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('tax')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('room_facility')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('account_info')).length > 0) {
			settingsPermissionForAgent = true;
		}

		let stayOverPermission = false;
		if (userCredentials.user_details?.user_type == "admin" || userCredentials.user_details?.user_type == "staff" || userCredentials.user_details?.user_type == "revenue_manager" || userCredentials.user_details?.user_type == "revenue_staff") {
			// Check if user has access to any home-related features
			const stayOverModules = ['stayover', 'booking_room', 'quotation'];
			stayOverPermission = stayOverModules.some(module =>
				Object.keys(Utility.getRoleObjectByEventKey(module)).length > 0
			);
		}

		let homePermission = false;
		if (userCredentials.user_details?.user_type == "admin" || userCredentials.user_details?.user_type == "staff" || userCredentials.user_details?.user_type == "revenue_manager" || userCredentials.user_details?.user_type == "revenue_staff") {
			// if (Object.keys(Utility.getRoleObjectByEventKey('booking_room')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('quotation')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('block_room')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('branch')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('room_type')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('staff')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('room_facility')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('credit_note')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('report')).length > 0) {
			// 	homePermission = true;
			// }

			// Check if user has access to any home-related features
			const homeModules = ['branch', 'room_type', 'staff', 'room_facility', 'credit_note', 'report', 'inventory', 'tour', 'room_features', 'variants', 'account_payment', 'block_room'];
			homePermission = homeModules.some(module =>
				Object.keys(Utility.getRoleObjectByEventKey(module)).length > 0
			);
		} else if (userCredentials.user_details?.user_type == "app_admin") {
			if (Object.keys(Utility.getRoleObjectByEventKey('hotels')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('admin')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('customer_rating')).length > 0) {
				homePermission = true;
			}
		}
		let homePermissionForAgent = false;
		if (userCredentials.user_details?.user_type == "agent" || userCredentials.user_details?.user_type == "agent_staff") {
			if (Object.keys(Utility.getRoleObjectByEventKey('branch')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('room_type')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('booking_room')).length > 0 || Object.keys(Utility.getRoleObjectByEventKey('quotation')).length > 0) {
				homePermissionForAgent = true;
			}
		}

		// Select Settings Menu
		let settingActionPage = "role";
		if (settingsPermission) {
			const roleObject = Utility.getRoleObjectByEventKey('role');
			if (Object.keys(roleObject).length === 0) {
				let settingActionPageFlag = true;
				["booking_rules", "cancellation_rules", "tax", "room_facility", "amenities", "slot_configuration", 'coupon'].forEach(tabMenu => {
					if (settingActionPageFlag && Object.keys(Utility.getRoleObjectByEventKey(tabMenu)).length > 0) {
						settingActionPageFlag = false;
						settingActionPage = tabMenu;
					}
				});
			}
		}

		// Select Settings Menu For Agent
		let settingActionPageForAgent = "role";
		if (settingsPermissionForAgent) {
			const roleObject = Utility.getRoleObjectByEventKey('role');
			if (Object.keys(roleObject).length === 0) {
				let settingActionPageFlagForAgent = true;
				["advance_percent", "cancellation_rules", "tax", "room_facility", "amenities", "account_info"].forEach(tabMenu => {
					if (settingActionPageFlagForAgent && Object.keys(Utility.getRoleObjectByEventKey(tabMenu)).length > 0) {
						settingActionPageFlagForAgent = false;
						settingActionPageForAgent = tabMenu;
					}
				});
			}
		}

		// Select Home Menu
		let homeActionPage = "branch";
		if (Object.keys(Utility.getRoleObjectByEventKey('branch')).length === 0) {
			let homeActionPageFlag = true;
			['branch', 'room_type', 'staff', 'room_facility', 'credit_note', 'report', 'inventory', 'tour', 'room_features', 'variants', 'block_room'].forEach(tabMenu => {
				if (homeActionPageFlag && Object.keys(Utility.getRoleObjectByEventKey(tabMenu)).length > 0) {
					homeActionPageFlag = false;
					homeActionPage = tabMenu;
				}
			});
		}

		// Select Home Menu
		let stayOverActionPage = "stayover";
		if (Object.keys(Utility.getRoleObjectByEventKey('booking_room')).length === 0) {
			let stayOverActionPageFlag = true;
			['stayover', 'booking_room', 'quotation'].forEach(tabMenu => {
				if (stayOverActionPageFlag && Object.keys(Utility.getRoleObjectByEventKey(tabMenu)).length > 0) {
					stayOverActionPageFlag = false;
					stayOverActionPage = tabMenu;
				}
			});
		}

		//for agent
		let homeActionPageForAgent = "agent_booking";
		if (Object.keys(Utility.getRoleObjectByEventKey('booking_room')).length === 0) {
			let homeActionPageForAgentFlag = true;
			const tabMenus = ['agent_booking', 'quotations', 'branch', 'room_type'];
			const keyMapping = {
				'agent_booking': 'booking_room',
				'quotations': 'quotation'
			};
			tabMenus.forEach(tabMenu => {
				const roleKey = keyMapping[tabMenu] || tabMenu;

				if (homeActionPageForAgentFlag && Object.keys(Utility.getRoleObjectByEventKey(roleKey)).length > 0) {
					homeActionPageForAgentFlag = false;
					homeActionPageForAgent = tabMenu;
				}
			});
		}

		let revenueManagerAccess = true;
		if (["agent", "agent_staff"].includes(userCredentials.user_details?.user_type)) {
			revenueManagerAccess = false
		}
		if (["staff"].includes(userCredentials.user_details?.user_type)) {
			if (Object.keys(Utility.getRoleObjectByEventKey('revenue_manager')).length > 0) {
				revenueManagerAccess = true
			} else {
				revenueManagerAccess = false
			}
		}
		if (["revenue_manager"].includes(userCredentials.user_details?.user_type)) {
			if (Object.keys(Utility.getRoleObjectByEventKey('revenue_manager')).length > 0) {
				revenueManagerAccess = true
			} else {
				revenueManagerAccess = false
			}
		}
		if (['revenue_staff'].includes(userCredentials.user_details?.user_type)) {
			if (userCredentials.user_details.revenue_staff_permissions.length == 0) {
				revenueManagerAccess = false
			} else {
				if (userCredentials.user_details.revenue_staff_permissions[0].can_read == 0 && userCredentials.user_details.revenue_staff_permissions[0].can_write == 0 && userCredentials.user_details.revenue_staff_permissions[0].can_delete == 0) {
					revenueManagerAccess = false
				}
			}

		}


		if (userCredentials.user_details?.is_subscribed && (userCredentials.user_details?.user_type == "admin" || userCredentials.user_details?.user_type == "staff" || userCredentials.user_details?.user_type == "revenue_manager" || userCredentials.user_details?.user_type == "revenue_staff") && Object.keys(Utility.getRoleObjectByEventKey('dashboard')).length > 0) {
			arry.push(
				<Nav.Item className={activeClass === 'dashboard_module' ? "ActiveClass" : "default dashboarditem"} onClick={this.toggle.bind(this, 'dashboard_module', '')} key={0}>
					<Link to={`/${localStorage.getItem('i18nextLng')}/dashboard`} className="nav-link">
						<div className="imgcircle dashboard">
							<OverlayTrigger overlay={<Tooltip>Data Insights</Tooltip>}>
								<img src={require('../Public/images/cort.png')} className="sidebaricon" />
							</OverlayTrigger>
						</div>
						{this.state.isMobile &&
							<h6>Data Insights</h6>
						}
					</Link>
				</Nav.Item>
			)
		}

		if (stayOverPermission && (userCredentials.user_details?.user_type == "admin" || userCredentials.user_details?.user_type == "staff" || userCredentials.user_details?.user_type == "revenue_manager" || userCredentials.user_details?.user_type == "revenue_staff")) {
			arry.push(
				<Nav.Item className={activeClass === 'stay_over_module' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'stay_over_module', '')} key={8}>
					<Link to={`/${localStorage.getItem('i18nextLng')}/home/${stayOverActionPage}`} className="nav-link">
						<div className="imgcircle">
							<OverlayTrigger overlay={<Tooltip>Reservations</Tooltip>}>
								<img src={require('../Public/images/booking.png')} className="sidebaricon" />
							</OverlayTrigger>
						</div>
						{this.state.isMobile &&
							<h6>Reservations</h6>
						}
					</Link>

				</Nav.Item>
			)
		}
		if (homePermission && (userCredentials.user_details?.user_type == "app_admin" || userCredentials.user_details?.user_type == "admin" || userCredentials.user_details?.user_type == "staff" || userCredentials.user_details?.user_type == "revenue_manager" || userCredentials.user_details?.user_type == "revenue_staff")) {
			arry.push(
				<Nav.Item className={activeClass === 'home_module' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'home_module', '')} key={1}>
					{userCredentials.user_details?.user_type == "app_admin" ?
						<Link to={`/${localStorage.getItem('i18nextLng')}/home/hotels`} className="nav-link">
							<div className="imgcircle">
								<OverlayTrigger overlay={<Tooltip>Reservation & Property Management</Tooltip>}>
									<img src={require('../Public/images/home.png')} className="sidebaricon" />
								</OverlayTrigger>
							</div>
							{this.state.isMobile &&
								<h6>Reservation & Property Management</h6>
							}
						</Link>
						:
						<Link to={`/${localStorage.getItem('i18nextLng')}/home/${homeActionPage}`} className="nav-link">
							{/* <Link to={`/${localStorage.getItem('i18nextLng')}/home/staff`} className="nav-link"> */}
							<div className="imgcircle">
								<OverlayTrigger overlay={<Tooltip>Property Management</Tooltip>}>
									<img src={require('../Public/images/home.png')} className="sidebaricon" />
								</OverlayTrigger>
							</div>
							{this.state.isMobile &&
								<h6>Property Management</h6>
							}
						</Link>
					}

				</Nav.Item>
			)
		}

		if (homePermissionForAgent && (userCredentials.user_details?.user_type == "agent" || userCredentials.user_details?.user_type == "agent_staff")) {
			arry.push(
				<Nav.Item className={activeClass === 'home_module' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'home_module', '', 'agent')} key={1}>

					<Link to={`/${localStorage.getItem('i18nextLng')}/agent/${homeActionPageForAgent}`} className="nav-link">
						{/* <Link to={`/${localStorage.getItem('i18nextLng')}/agent/staff`} className="nav-link"> */}
						<div className="imgcircle">
							<OverlayTrigger overlay={<Tooltip>Reservation & Property Management</Tooltip>}>
								<img src={require('../Public/images/home.png')} className="sidebaricon" />
							</OverlayTrigger>
						</div>
						{this.state.isMobile &&
							<h6>Reservation & Property Management</h6>
						}
					</Link>
				</Nav.Item>
			)
		}
		// Reports Module Menu Item
		if (userCredentials.user_details?.is_subscribed && (["admin", "staff", "agent", "agent_staff"].includes(userCredentials.user_details?.user_type) && Object.keys(Utility.getRoleObjectByEventKey('reports')).length > 0)) {
			arry.push(
				<Nav.Item className={activeClass === 'reports_module' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'reports_module', '')} key={2}>
					<Link to={userCredentials.user_details?.is_subscribed && (["agent", "agent_staff"].includes(userCredentials.user_details?.user_type)) ? `/${localStorage.getItem('i18nextLng')}/reports/gstr1_report` : `/${localStorage.getItem('i18nextLng')}/reports`} className="nav-link">
						<div className="imgcircle">
							<OverlayTrigger overlay={<Tooltip>Reports</Tooltip>}>
								<img src={require('../Public/images/chart.png')} className="sidebaricon" />
							</OverlayTrigger>
						</div>
						{this.state.isMobile &&
							<h6>Reports</h6>
						}
					</Link>
				</Nav.Item>
			)
		}

		//Reports Module Menu Item
		if (userCredentials.user_details?.is_subscribed && (["admin", "staff"].includes(userCredentials.user_details?.user_type) && Object.keys(Utility.getRoleObjectByEventKey('accounts')).length > 0)) {
			arry.push(
				<Nav.Item className={activeClass === 'account_module' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'account_module', '')} key={9}>
					<Link to={`/${localStorage.getItem('i18nextLng')}/accounts`} className="nav-link">
						<div className="imgcircle">
							<OverlayTrigger overlay={<Tooltip>Accounts</Tooltip>}>
								<img src={require('../Public/images/accounting.png')} className="sidebaricon" />
							</OverlayTrigger>
						</div>
						{this.state.isMobile &&
							<h6>Accounts</h6>
						}
					</Link>
				</Nav.Item>
			)
		}
		// Reports Module Menu Item
		//if (userCredentials.user_details?.is_subscribed && (["admin", "staff", "agent", "agent_staff"].includes(userCredentials.user_details?.user_type) && Object.keys(Utility.getRoleObjectByEventKey('revenue_manager')).length > 0)) {
		if (userCredentials.user_details?.is_subscribed && userCredentials.user_details?.is_revenue_manager_enabled && (["admin", "staff", "revenue_manager", "revenue_staff"].includes(userCredentials.user_details?.user_type)) && revenueManagerAccess) {
			arry.push(
				<Nav.Item className={activeClass === 'revenue_module' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'revenue_module', '')} key={3}>
					<Link to={`/${localStorage.getItem('i18nextLng')}/revenue-manager`} className="nav-link">
						<div className="imgcircle">
							<OverlayTrigger overlay={<Tooltip>Revenue Manager</Tooltip>}>
								<img src={require('../Public/images/priceQuotation.png')} className="sidebaricon" />
							</OverlayTrigger>
						</div>
						{this.state.isMobile &&
							<h6>Revenue Manager</h6>
						}
					</Link>
				</Nav.Item>
			)
		}

		if ((userCredentials.user_details?.is_subscribed || userCredentials.user_details?.user_type == "app_admin") && settingsPermission && (userCredentials.user_details?.user_type == "app_admin" || userCredentials.user_details?.user_type == "admin" || userCredentials.user_details?.user_type == "staff" || userCredentials.user_details?.user_type == "revenue_manager" || userCredentials.user_details?.user_type == "revenue_staff")) {
			arry.push(
				<Nav.Item className={activeClass === 'settings_module' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'settings_module', '')} key={4}>
					{userCredentials.user_details?.user_type == "app_admin" ?
						<Link to={`/${localStorage.getItem('i18nextLng')}/settings/room_facility`} className="nav-link">
							<div className="imgcircle settings">
								<OverlayTrigger overlay={<Tooltip>Configuration Control pannel</Tooltip>}>
									<img src={require('../Public/images/roleicon.png')} className="sidebaricon" />
								</OverlayTrigger>
							</div>
							{this.state.isMobile &&
								<h6>Configuration Control pannel</h6>
							}
						</Link>
						:
						<Link to={`/${localStorage.getItem('i18nextLng')}/settings/${settingActionPage}`} className="nav-link">
							<div className="imgcircle settings">
								<OverlayTrigger overlay={<Tooltip>Configuration Control pannel</Tooltip>}>
									<img src={require('../Public/images/roleicon.png')} className="sidebaricon" />
								</OverlayTrigger>
							</div>
							{this.state.isMobile &&
								<h6>Configuration Control pannel</h6>
							}
						</Link>
					}
				</Nav.Item>
			)
		}
		if (userCredentials.user_details?.is_subscribed && settingsPermissionForAgent && (userCredentials.user_details?.user_type == "agent" || userCredentials.user_details?.user_type == "agent_staff")) {
			arry.push(
				<Nav.Item className={activeClass === 'settings_module_agent' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'settings_module_agent', '', 'agent_settings')} key={5}>

					<Link to={`/${localStorage.getItem('i18nextLng')}/agent_settings/${settingActionPageForAgent}`} className="nav-link">
						{/* <Link to={`/${localStorage.getItem('i18nextLng')}/agent_settings/advance_percent`} className="nav-link"> */}
						<div className="imgcircle settings">
							<OverlayTrigger overlay={<Tooltip>Configuration Control pannel</Tooltip>}>
								<img src={require('../Public/images/roleicon.png')} className="sidebaricon" />
							</OverlayTrigger>
						</div>
						{this.state.isMobile &&
							<h6>Configuration Control pannel</h6>
						}
					</Link>
				</Nav.Item>
			)
		}

		if ((userCredentials.user_details?.is_subscribed) && (["admin", "staff"].includes(userCredentials.user_details?.user_type))) {
			arry.push(
				<Nav.Item className={activeClass === 'login_activity_module' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'login_activity_module', '')} key={6}>
					<Link to={`/${localStorage.getItem('i18nextLng')}/login-activities`} className="nav-link">
						<div className="imgcircle settings">
							<OverlayTrigger overlay={<Tooltip>Login Activities</Tooltip>}>
								<img src={require('../Public/images/access-time.png')} className="sidebaricon" />
							</OverlayTrigger>
						</div>
						{this.state.isMobile &&
							<h6>Login Activities</h6>
						}
					</Link>
				</Nav.Item>
			)
		}

		if ((userCredentials.user_details?.is_subscribed) && (["admin", "staff"].includes(userCredentials.user_details?.user_type))) {
			arry.push(
				<Nav.Item className={activeClass === 'housekeeping_module' ? "ActiveClass" : "default"} onClick={this.toggle.bind(this, 'housekeeping_module', '')} key={7}>
					<Link to={`/${localStorage.getItem('i18nextLng')}/housekeeping`} className="nav-link">
						<div className="imgcircle">
							<OverlayTrigger overlay={<Tooltip>Housekeeping</Tooltip>}>
								<img src={require('../Public/images/housekeeping.png')} className="sidebaricon" />
							</OverlayTrigger>
						</div>
						{this.state.isMobile &&
							<h6>Housekeeping</h6>
						}
					</Link>
				</Nav.Item>
			)
		}

		return arry;
	}

	toggleSidebar = () => {
		if (this.state.isMobile) {
			this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
			this.props.handleLeft(!this.props.leftbar)
		}
	};
	// Handle window resize to detect mobile view
	handleResize = () => {
		this.setState({ isMobile: window.innerWidth <= 767 });
	};

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
		if (window.innerWidth >= 767) {
			this.props.handleLeft(false);
		}
		document.body.addEventListener('mousedown', this.handleClickOutsideSidebar.bind(this));
	}

	componentDidUpdate(prevProps) {
		const prevUserEntry = prevProps.userEntryType?.value || prevProps.userEntryType?.id;
		const currUserEntry = this.props.userEntryType?.value || this.props.userEntryType?.id;
		const userType = (this.props.userEntryType?.user_type || "").toString().toLowerCase();
		if (prevUserEntry !== currUserEntry && (userType === 'admin')) {
			this.props.handleActiveLink('dashboard_module', '');
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	logsPopupFn = () => {
		this.setState({ logsPopupFlag: true });
	}

	closeLogsPopupFn = () => {
		this.setState({ logsPopupFlag: false });
	}

	render() {
		const { activeClass, accName } = this.props.activeLink;
		const { isOpen, isMobile } = this.state;
		return (
			<>
				{/* <aside id="left_bar_id" className={this.props.leftbar ? 'left_bar_customize left-bar open hide-sm' : 'left_bar_customize left-bar closed hide-sm'}>
					<div className="webtitlelogo"><OverlayTrigger overlay={<Tooltip>TheInnSight.AI</Tooltip>}><img src={require('../Public/images/logoWhite.png')} className="" /></OverlayTrigger></div>
					<Nav className="flex-column pt-2 side-nav">
						{this.leftUi()}
					</Nav>
				</aside> */}

				<aside
					id="left_bar_id"
					className={`left_bar_customize left-bar ${isMobile ? 'left_bar_customizeMobile' : ''} ${isMobile ? (isOpen ? 'open' : 'closed') : (this.props.leftbar ? 'open' : 'closed')}`}
					ref={this.sidebarOutsideClickRef}
				>
					<div className="sidebar-header">
						<div className="webtitlelogo">
							<OverlayTrigger placement="bottom" overlay={<Tooltip>MettaStay</Tooltip>}>
								<img src={require('../Public/images/logoWhite.png')} alt="Logo" />
							</OverlayTrigger>
						</div>
						{isMobile && (
							<button className="menuIcon" onClick={this.toggleSidebar}>
								<i className="fa fa-bars" aria-hidden="true"></i>
							</button>
						)}
						{isOpen && isMobile && (
							<button className="menuIcon close-btn" onClick={this.toggleSidebar}>
								<i className="fa fa-times" aria-hidden="true"></i>
							</button>
						)}
					</div>
					<Nav className="flex-column pt-0 side-nav">
						{this.leftUi()}
					</Nav>
					{(this.props.userCredentials.user_details?.is_subscribed && (["admin"].includes(this.props.userCredentials.user_details?.user_type))) ?
						<div className="logs-icon-box">
							<OverlayTrigger overlay={<Tooltip>Logs</Tooltip>}>
								<button type="button" onClick={this.logsPopupFn}>
									<img src={require('../Public/images/log.png')} alt="Logs" />
									{this.state.isMobile &&
										<h6>Logs</h6>
									}
								</button>
							</OverlayTrigger>


						</div> : null}
				</aside>
				{/* Job Dashboard modal */}
				<ErrorBoundary title="ModalGlobal Error">
					<ModalGlobal
						show={this.state.logsPopupFlag}
						onHide={this.closeLogsPopupFn}
						title="Logs"
						className={`modalcustomize mondimension logs-modal-dialog`}
						footer={false}
						closeButton={true}
						saveButtonLabel="Submit"
						saveButtonClassName="btn btn-primary savebtn"
						cancelShow={true}
						body={
							<>
								<ErrorBoundary title="Logs Error">
									<Logs />
								</ErrorBoundary>
							</>
						}
					/>
				</ErrorBoundary>
			</>
		)
	}
}


function mapStateToProps(globalState) {
	return {
		leftbar: globalState.mainReducerData.leftbar,
		activeLink: globalState.mainReducerData.activeLink,
		roleWisePermission: globalState.mainReducerData.roleWisePermission,
		userCredentials: globalState.LoginReducer.userCredentials,
		userEntryType: globalState.LoginReducer.userEntryType,
		loginDetails: globalState.LoginReducer

	};
}

export default connect(mapStateToProps, { handleActiveLink, handleLeft, setToken })(Left);